var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "edit_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.88 2.68c.99.02 1.91.44 2.58 1.18l-.01.01c1.3 1.42 1.22 3.63-.17 5.02l-.02.02.02.02L10.11 19.1c-.36.36-.8.62-1.28.76L5.4 20.87a1.764 1.764 0 0 1-1.75-.45c-.45-.46-.62-1.13-.44-1.75l1.01-3.43c.14-.48.4-.93.76-1.28L15.15 3.79l.02.02.08-.08c.69-.69 1.64-1.07 2.63-1.05M5.251 18.827l2.35-.697-1.66-1.66zm1.79-4.087 2.3 2.3v-.01l8.11-8.11-2.3-2.3zM17.82 4.68c-.46-.01-.86.16-1.17.47v-.01l-.08.08 2.27 2.27.02-.02c.63-.62.68-1.64.11-2.26-.3-.33-.71-.52-1.15-.53",
  clipRule: "evenodd"
})));
export default SvgEdit;